import React, { useState, useEffect, useRef } from "react";
import classNames from 'classnames';
import useDropdownToggle from "../../customHooks/useDropdownToggle";

const DropdownWithSearch = ({
  title = '',
  listItems = [],
  onChange = () => { },
  prefixIcon = null,
  suffixIcon = null,
  iconHeight = '9px',
  iconWidth = '14px',
  border = '',
  borderRadius = '',
  padding = 'pl-4 pr-15 pt-2.5',
  bg = 'bg-transparent',
  font = 'font-semibold text-gray-600 text-base',
  // minWidth = 'min-w-max',
  maxWidth = 'min-w-max',
  margin = '',
  selected = Boolean,
  type,
  ...props
}) => {
  const { clearSelection, clearText = null, disabled } = props
  const [list, updateList] = useState([...listItems])
  const { show, toggle, ref } = useDropdownToggle()
  const inputRef = useRef()

  useEffect(() => {
    updateList([...listItems])
  }, [listItems])

  useEffect(() => {
    if (show && inputRef.current) {
      inputRef.current.focus()
    }
  }, [show])

  const handleChange = (item) => {
    onChange(item)
    inputRef.current.value = ''
    updateList([...listItems])
    toggle()
  };

  const clearItem = () => {
    clearSelection()
    toggle()
  }

  const filterSearch = (e) => {
    updateList(listItems.filter((item) => item[type]?.toLowerCase()?.indexOf(e.target.value.toLowerCase()) !== -1))
  }

  return (
    <div ref={ref} className={`${maxWidth} ${margin} inline-block relative z-10`} style={{ minWidth: "236px", background: "#F9FAFB" }}>
      <button
        type='button'
        disabled={disabled}
        className={classNames(
          `inline-flex ${bg} ${padding} ${border} ${borderRadius} ${disabled ? 'cursor-not-allowed' : ''} whitespace-nowrap items-center w-full ${font}`)}
        onClick={toggle}
      >
        <span>
          {title}
        </span>
        <img className={classNames(suffixIcon ? '' : 'hidden', type=== 'city' ? 'ml-24' : 'ml-16')} src={suffixIcon} height={iconHeight} width={iconWidth} />
        <span>
        </span>
      </button>
      <div className={classNames(
        show ? '' : 'hidden',
        `absolute z-30 ${maxWidth} text-sm font-semibold text-gray-600 mt-0 py-2 bg-white rounded-md shadow cursor-pointer`
      )} role='listbox'>
        <div className='flex text-gray-300 bg-gray-100 text-sm items-center mx-2 py-3 pl-3.5 border rounded-lg'>
          <label htmlFor='input-search'><img pointer className='mr-3' src={prefixIcon} height='11px' width='11px' /></label>
          <input ref={inputRef} id='input-search' onClick={() => inputRef.current.focus()} onChange={(e) => filterSearch(e)} className='w-full bg-gray-100 focus:bg-gray-100 focus:text-gray-600 outline-none font-semibold' placeholder='Search' />
        </div>
        <div className='max-h-80 overflow-y-scroll flex flex-col'>
          {list.map((item) => {
            return (
              <a
                onClick={() => handleChange(item)}
                className='py-4 pl-6 inline-flex pr-12 w-full hover:bg-blue-100'
                role='option'
                key={item.id}
              >
                <span>{item[type]}</span>
              </a>
            )
          })
          }
        </div>
        <p
          hidden={!selected}
          onClick={clearItem}
          className={`${!clearText ? 'hidden' : ''} py-4 pl-6 pr-12 w-full text-center text-blue-500 bg-blue-100`}
          role='button'>
          {clearText}
        </p>
      </div>
    </div>
  )
}

export default DropdownWithSearch;